<h2 mat-dialog-title style="font-weight: normal; padding: 1.5rem 1.5rem 0px 1.5rem">
	{{data.modalTitle}}
</h2>
<mat-divider></mat-divider>

<mat-dialog-content style="padding: 1.5rem 1.5rem 1rem 1.5rem; margin: 1px">
	<div
		*ngIf="!data.isEditable && data.specialInstructions != undefined && data.specialInstructions != null && data.specialInstructions.length > 0"
	>
		{{data.specialInstructions}}
	</div>

	<div *ngIf="data.isEditable">
		<mat-form-field floatLabel="never" fxFlex>
			<mat-label>Start Typing here</mat-label>
			<textarea [(ngModel)]="data.specialInstructions" matInput></textarea>
		</mat-form-field>
	</div>

	<div
		*ngIf="!data.isEditable && (data.specialInstructions == undefined ||
		data.specialInstructions == null || data.specialInstructions.length == 0)"
		fxLayoutAlign="center center"
	>
		No instructions provided.
	</div>
</mat-dialog-content>
<mat-divider></mat-divider>

<mat-dialog-actions style="padding: 1.5rem 1.5rem 1rem 1.5rem; margin: 1px">
	<div fxFlex="100" fxLayoutAlign="end center" fxLayoutGap="1rem">
		<span (click)="closeDialog(null)" *ngIf="data.displaySecondaryButton" class="link">
			{{data.secondaryButtonText}}
		</span>

		<button
			(click)="closeDialog(data.isEditable ? data.specialInstructions : null)"
			color="primary"
			mat-raised-button
		>
			{{data.primaryButtonText}}
		</button>
	</div>
</mat-dialog-actions>
